import "./style.scss";

export function featured_post_block() {
  const block = document.querySelector(".featured_post_block");
  if (!block) return;
}
